import { AxiosError } from "axios";

export const getApiErrorMessage = (error: unknown): string => {
  if (error instanceof AxiosError && error.response?.status === 422 && error.response?.data?.errors) {
    return JSON.stringify(error.response.data.errors);
  }

  if (error instanceof Error) {
    return error.message;
  }

  return "Unexpected error!";
};
